import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

interface InCellDivisionStyledProps {
  $maxWidth?: string;
  $withBorder: boolean;
}

export const InCellDivisionStyled = styled.div<InCellDivisionStyledProps>`
  box-sizing: border-box;
  padding-bottom: 0.8rem;
  margin-bottom: 0.8rem;
  max-width: ${({ $maxWidth }: InCellDivisionStyledProps): CSSProp => $maxWidth || '100%'};
  border-bottom: ${({ $withBorder }: InCellDivisionStyledProps): CSSProp =>
    $withBorder ? `1px solid ${colors.neutral[200]}` : 'none'};

  &:last-of-type {
    border: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;
